import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '@app/core/config/config.service';
import { AuthService } from '@app/core/guards/auth.service';
import { HttpService } from '@app/core/http/http.service';
import { ReferentialModel } from '@app/core/models/referentials/referential.model';
import { ExpenseFamilyTypeRef } from '../models/referentials/expense-family-type.model';
import { VatRef } from '../models/referentials/vat.model';
import { InvoicePPRTypeRef } from '../models/referentials/invoice-ppr-type.model';
import { DeductionTypeRef } from '../models/referentials/deduction-type.model';
import { CompanyRef } from '../models/referentials/company.model';

@Injectable({
  providedIn: 'root',
})
export class ReferentialService extends HttpService {
  constructor(
    protected http: HttpClient,
    protected config: ConfigService,
    protected authService: AuthService
  ) {
    super(http, config, authService, 'referentials');
  }

  getGroupTypes(): Observable<ReferentialModel[]> {
    const groupTypes = this.invokeGet<ReferentialModel[]>('groupTypes');
    return groupTypes;
  }

  getRejectionFlags(): Observable<ReferentialModel[]> {
    const rejectionFlags = this.invokeGet<ReferentialModel[]>('rejectionFlags');
    return rejectionFlags;
  }

  getWaitingFlags(): Observable<ReferentialModel[]> {
    const waitingFlags = this.invokeGet<ReferentialModel[]>('waitingFlags');
    return waitingFlags;
  }

  getRecyclingFlags(): Observable<ReferentialModel[]> {
    const recyclingFlags = this.invokeGet<ReferentialModel[]>('recyclingFlags');
    return recyclingFlags;
  }

  getProfessionTypes(): Observable<ReferentialModel[]> {
    const groupTypes = this.invokeGet<ReferentialModel[]>('professionTypes');
    return groupTypes;
  }

  getAssetTypes(): Observable<ReferentialModel[]> {
    const assetTypes = this.invokeGet<ReferentialModel[]>('assetTypes');
    return assetTypes;
  }

  getVatRef(): Observable<VatRef[]> {
    const refs = this.invokeGet<VatRef[]>('VAT');
    return refs;
  }

  getExpenseFamilyTypes(): Observable<ExpenseFamilyTypeRef[]> {
    const refs = this.invokeGet<ExpenseFamilyTypeRef[]>('ExpenseFamilyType');
    return refs;
  }

  getInvoicePPRTypes(): Observable<InvoicePPRTypeRef[]> {
    const refs = this.invokeGet<InvoicePPRTypeRef[]>('InvoicePPRType');
    return refs;
  }

  getDeductionType(): Observable<DeductionTypeRef[]> {
    const refs = this.invokeGet<DeductionTypeRef[]>('Deduction');
    return refs;
  }

  getTypologieTypes(): Observable<ReferentialModel[]> {
    const data = this.invokeGet<ReferentialModel[]>('TypologieType');
    return data;
  }

  getCompany(): Observable<CompanyRef[]> {
    const data = this.invokeGet<CompanyRef[]>('Company');
    return data;
  }

  getTreeLevel(): Observable<ReferentialModel[]> {
    const data = this.invokeGet<ReferentialModel[]>('TreeLevel');
    return data;
  }

  getExpenseTradeTypes(): Observable<ReferentialModel[]> {
    const refs = this.invokeGet<ReferentialModel[]>('ExpenseTradeType');
    return refs;
  }

  getEmailTemplateTypes(): Observable<ReferentialModel[]> {
    const emailTemplateTypes =
      this.invokeGet<ReferentialModel[]>('emailTemplateTypes');
    return emailTemplateTypes;
  }
}
